import { PieChart, Pie, Cell } from "recharts";
import { ChartContainer } from "./charts";
import { useTheme } from "styled-components";


interface PropsType {
  isRing?: boolean;
  hasNumber?: boolean;
  text: string;
  data: any;
}

const CustomPieChart = ({ isRing, hasNumber, text, data }: PropsType) => {
  const theme = useTheme();
  const inner = isRing ? 60 : 100;
  const outer = isRing ? 75 : 120;
  const hw = isRing ? 160 : 300;
  const c = isRing ? 75 : 85;
  const xy = isRing ? 80 : 88;
  
  // Still show a default pie chart if no category has a value greater than 0
  let textCategory;
  const totalCategoriesLargerThan0 = data.filter((category) => category.value !== 0);

  if (hasNumber) {
    textCategory = data.find((item) => item.name.toLowerCase() === text.toLowerCase());
  }

  if (totalCategoriesLargerThan0.length === 0) {
    // If no category is found we should just display the text
    if (textCategory) {
      // Set the default data
      data = [
        {
          name: "No Data",
          value: 100,
          color: textCategory.color,
        }
      ];
    }
  }
  
  return (
    <ChartContainer>
      { 
        data && data.length > 0 ? 
        <PieChart width={hw} height={hw}>
          <Pie
            data={data}
            cx={c}
            cy={c}
            innerRadius={inner}
            outerRadius={outer}
            stroke=""
            dataKey="value"
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={totalCategoriesLargerThan0.length > 0 ? entry.color : theme.colors.mediumGrey} />
            ))}
          </Pie>
          { 
            // If we want to display the sum and name of a category
            hasNumber ? <>
              <text
                x={xy}
                y={xy - 15}
                fill={theme.colors.textColor}
                textAnchor="middle"
                fontSize="1.4em"
                fontWeight={300}
                dominantBaseline="central"
              >
                <tspan alignmentBaseline="middle" className="fill-color">
                  {textCategory.value}
                </tspan>
              </text>
              <text
                x={xy}
                y={xy + 10}
                fill={theme.colors.textColor}
                textAnchor="middle"
                fontSize="1em"
                fontWeight={300}
                dominantBaseline="central"
              >
                <tspan className="fill-color">
                  {textCategory.name}
                </tspan>
              </text>      
            </> :
            // If we want to display the given text value
            <text
              x={xy}
              y={xy}
              fill={theme.colors.textColor}
              textAnchor="middle"
              fontSize="1em"
              fontWeight={300}
              dominantBaseline="central"
            >
              <tspan className="fill-color">
                {text}
              </tspan>
            </text>   
          }
        
        </PieChart> :
        <></>
      }
    </ChartContainer>
  );
};

export default CustomPieChart;


